import React from 'react'
import PropTypes from 'prop-types'

import ReviewsBadge from './reviews-badge'

const MobileReviews = ({ reviews }) => {
  return (
    <div className='mobile-reviews hide-when-big'>
      <ReviewsBadge reviews={reviews} />
    </div>
  )
}

MobileReviews.propTypes = {
  reviews: PropTypes.object
}

export default MobileReviews
